import React, {Component} from "react";
import FJTimeLineTool from 'fj-components/FJTimeLineTool';
import {connect} from 'react-redux'
import {FJTimeLineAction} from "../../../redux/action/FJRoot.action";
import FJLocalStore from '../../../store/FJLocalStore';
import FJTimelineStore from "fj-timeline";
import FJUtil from '../../../util/FJUtil';
import styles from '../css/FJTimelineToolContainer.module.less';
import fit from '../../../icon/fit.svg';
import zoomIn from '../../../icon/zoomin.svg';
import zoomOut from '../../../icon/zoomout.svg';
import FJTimeProgress from "./FJTimeProgress";

class FJTimelineToolContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {handleClass: ''};
    this.timelineTool = React.createRef();
    this.classes = {
      toolBoxClassName: styles.tool_container,
      timeClassName: styles.time_class,
      timeDisabledClassName: styles.time_disabled,
    };
    this.config = {
      otherWidth: 245,
      fitIcon: fit,
      zoomInIcon: zoomIn,
      zoomOutIcon: zoomOut
    };
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.props.duration !== nextProps.duration
      || this.props.unitConversion !== nextProps.unitConversion
      || this.props.selectedId !== nextProps.selectedId
      || this.state.handleClass !== nextState.handleClass
  }

  /**
   * @description 返回DOM节点
   * @return {unknown}
   */
  getDomNode = () => {
    return this.timelineTool.current.getDomNode();
  };

  /**
   * @description 做埋点统计
   * @param type
   * @private
   */
  _doStatistics = (type) => {
    if (type === 'app_fit to screen click') {
      FJUtil.ealog('timeline_fit to screen click');
    } else {
      FJUtil.ealog(type);
    }
  };

  _changeUnitConversion = (type, progress) => {
    if ( type === 'start' ) {
      this.setState({
        handleClass: styles.drag_handle
      });
    } else if ( type === 'end' ) {
      this.setState({
        handleClass: ''
      });
    }
    this.props.changeUnitConversion(type, progress);
  };

  _renderTimeProgress = (className) => {
    return (
        <FJTimeProgress allDuration={this.props.duration} className={className}/>
    )
  }

  render() {
    const {duration, unitConversion, selectedId} = this.props;
    const {setTimelineUnitConversion, changeTimeLineHeightRadio, renderTimelineToolLeft} = this.props;
    const {handleClass} = this.state;
    let classes = Object.assign(this.classes, {
      toolRightClasses: {
        btnClassName: styles.tool_right_button,
        btnDisabledClassName: styles.tool_right_button_disabled,
        progressClassName: styles.progress_box,
        sliderClasses: {
          sliderBoxClassName: styles.slider_box,
          railClassName: duration === 0 ? styles.disabled_rail : styles.rail,
          trackClassName: duration === 0 ? styles.track_disable : styles.track,
          handleClassName: styles.handle + ' ' + handleClass,
          disableClassName: styles.disabled
        }
      }
    })
    return (
      <FJTimeLineTool ref={this.timelineTool}
                      allDuration={duration}
                      changeUnitConversion={this._changeUnitConversion}
                      setTimelineUnitConversion={setTimelineUnitConversion}
                      selectedId={selectedId}
                      changeTimeLineHeightRadio={changeTimeLineHeightRadio}
                      renderTimelineToolLeft={renderTimelineToolLeft}
                      renderTimeProgress={this._renderTimeProgress}
                      unitConversion={unitConversion}
                      minUnitConversion={FJTimelineStore.getMinUnitConversion()}
                      maxUnitConversion={FJTimelineStore.getMaxUnitConversion()}
                      fitToScreenText={FJLocalStore._('fit-to-screen')}
                      zoomOutText={FJLocalStore._('zoom-out')}
                      zoomInText={FJLocalStore._('zoom-in')}
                      doStatistics={this._doStatistics}
                      classes={classes}
                      config={this.config}
      />
    );
  }
}

const mapStateToProps = function (state) {
  return {
    duration: state.timeline.duration,
    selectedId: state.timeline.selectedId,
    unitConversion: state.timeline.unitConversion
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    setTimelineUnitConversion: function (data) {
      dispatch(FJTimeLineAction.setTimelineUnitConversionAction(data));
    },
    changeUnitConversion: function (type, progress) {
      dispatch(FJTimeLineAction.changeUnitConversionAction(type, progress));
    },
    changeTimeLineHeightRadio: function (type, value) {
      dispatch(FJTimeLineAction.changeTimeLineHeightRadio(type, value));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJTimelineToolContainer);
